import type { RouteObject } from 'react-router-dom';
import { ROUTE_LABS_ALL } from '../../../constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { Page } from './labs-all.page';

export const routeLabsAll: RouteObject = {
  path: ROUTE_LABS_ALL,
  Component: Page,
  loader: setTitleFromLoader('All Biomarkers'),
};
